import { createApiClient } from '@aimsos/api-client';
import { tokenService, clearAuthAndRedirect } from '@aimsos/auth';

/**
 * Lazily-constructed HTTP client for the Unified Profiles app.
 *
 * Built on first property access rather than at module load, so the shell has
 * already injected `window.__AIMS_SHELL__` by the time we read the base URL.
 * Mirrors `apps/dashboards/src/services/apiClient.js`.
 */
function lazyClient(urlKey) {
  let instance = null;
  return new Proxy(
    {},
    {
      get(_, prop) {
        if (!instance) {
          const shell = window.__AIMS_SHELL__ || {};
          instance = createApiClient({
            baseURL: shell[urlKey] || '',
            getToken: () => tokenService.getToken(),
            refreshToken: () => tokenService.refreshToken(),
            onAuthFailure: clearAuthAndRedirect,
          }).client;
        }
        const value = instance[prop];
        return typeof value === 'function' ? value.bind(instance) : value;
      },
    },
  );
}

/**
 * HTTP client for the Unified Profiles backend.
 *
 * TODO(CT-5277 / backend): no entity endpoint exists yet, so every resource in
 * this folder is served from the mock seeds via `mockTransport.js`. The client
 * is wired now so the cutover is one flag, not a rewrite.
 */
export const apiUnifiedProfiles = lazyClient('apiBaseUrl');

/** Common path prefix for every Unified Profiles backend resource. */
export const UNIFIED_PROFILES_API_PREFIX = '/v1/workspace/profiles';
